import Vue from 'vue'
import Model from './Model.vue'

const ImgManagerConstructor = Vue.extend(Model)

function imgManager(options = {}, onClose) {
  console.log(onClose);
  if (typeof onClose === 'function') {
    options.onClose = onClose
  }

  const instance = new ImgManagerConstructor({
    propsData: options
  })

  instance.vm = instance.$mount()
  document.body.appendChild(instance.vm.$el)
  instance.vm.visible = true
}

export default imgManager
